export default "__VITE_ASSET__Cry1du67__"